import { useTranslation } from "react-i18next";
import { NumericFormat as NumberFormat } from "react-number-format";
import { useDispatch, useSelector } from "react-redux";
import { getClassName } from "../../../../../../components/Converter";
import RenderFor, { BM_TYP } from "../../../../../../components/RenderFor";
import { RowBody } from "../../../../../../components/RowValue/RowBody";
import { decimalSeparator, thousandSeparator } from "../../../../../../i18n";
import {
  selectTeilsicherheitsbeiwertZement,
  setTeilsicherheitsbeiwertZement,
} from "../../../../../../store/slices/innereSlice";

function TeilsicherheitsbeiwertZement() {
  const { t } = useTranslation("translation");
  const dispatch = useDispatch();

  const teilsicherheitsbeiwertZement = useSelector(selectTeilsicherheitsbeiwertZement);

  return (
    <RowBody
      titleValue={
        <p>{t("inner.buckling.ofner.parameterGroutingBody.partialSafetyFactorCement")}</p>
      }
      indicesValue={
        <span>
          &gamma;<sub>c</sub>
        </span>
      }
      inputValue={
        <>
          <RenderFor types={[BM_TYP.GERMANY]}>
            <span className="input">{teilsicherheitsbeiwertZement}</span>
          </RenderFor>

          <RenderFor types={[BM_TYP.EUROCODE_7]}>
            <NumberFormat
              className={getClassName(teilsicherheitsbeiwertZement)}
              value={teilsicherheitsbeiwertZement}
              decimalSeparator={decimalSeparator()}
              thousandSeparator={thousandSeparator()}
              displayType="input"
              type="text"
              onValueChange={(value) => {
                dispatch(setTeilsicherheitsbeiwertZement(value.floatValue));
              }}
              allowNegative={true}
            />
          </RenderFor>
        </>
      }
    />
  );
}

export default TeilsicherheitsbeiwertZement;
